import { ADVENTURE_GREEN, SENSATION_WHITE } from '../colors';

// Specifies style of text selection
export const baseSelectionStyle = `
  ::selection, *::selection {
    color: ${SENSATION_WHITE};
    background-color: ${ADVENTURE_GREEN};
  }
`;